<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <cuenta-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import CuentaProvider from "../../../../providers/CuentaProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import CuentaForm from "../CuentaForm";
    
    


    export default {
        name: "CuentaCreate",
         
        components: { CuentaForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.cuenta.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    nombre: '',
                    numero: null
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    CuentaProvider.createCuenta(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createCuenta)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

